import React, { useEffect, useState } from 'react';
import { Shape } from './Types';
import SetupHeader from './components/SetupHeader';
import PreviewCanvas from './components/PreviewCanvas';
import SetupControls from './components/SetupControls';
import { DEFAULT_MASK_SIZE, DEFAULT_NUMBER_OF_PINS, DEFAULT_PATH_LENGTH } from './AppConst';

interface SetupProps {
  selectedImage: string;
  onRun: (
    selectedImage: string,
    selectedShape: Shape,
    invertImage: boolean,
    maskSize: number,
    pathLength: number,
    numberOfPins: number,
  ) => void;
  onBack: () => void;
}

const Setup: React.FC<SetupProps> = ({ selectedImage: initialImage, onRun, onBack }) => {
  const [selectedImage, setSelectedImage] = useState(initialImage);
  const [selectedShape, setSelectedShape] = useState<Shape>('ellipse');
  const [invertImage, setInvertImage] = useState(false);
  const [maskSize, setMaskSize] = useState(DEFAULT_MASK_SIZE);
  const [pathLength, setPathLength] = useState(DEFAULT_PATH_LENGTH);
  const [numberOfPins, setNumberOfPins] = useState(DEFAULT_NUMBER_OF_PINS);

  useEffect(() => {
    setSelectedImage(initialImage);
  }, [initialImage]);

  return (
    <div className="text-center mt-12 px-4">
      <SetupHeader
        onBack={onBack}
        onRun={onRun}
        selectedImage={selectedImage}
        selectedShape={selectedShape}
        invertImage={invertImage}
        maskSize={maskSize}
        pathLength={pathLength}
        numberOfPins={numberOfPins}
      />

      <div className="my-8">
        <h3 className="text-2xl font-semibold mb-6">Preview</h3>
        <PreviewCanvas
          selectedImage={selectedImage}
          selectedShape={selectedShape}
          invertImage={invertImage}
          maskSize={maskSize}
          numberOfPins={numberOfPins}
        />

        <SetupControls
          selectedShape={selectedShape}
          invertImage={invertImage}
          maskSize={maskSize}
          pathLength={pathLength}
          numberOfPins={numberOfPins}
          onShapeChange={setSelectedShape}
          onInvertChange={setInvertImage}
          onMaskSizeChange={setMaskSize}
          onPathLengthChange={setPathLength}
          onNumberOfPinsChange={setNumberOfPins}
        />
      </div>
    </div>
  );
};

export default Setup;
